import { gql } from '@apollo/client';
export const NOTIFICATION_FIELDS = gql `
  fragment NotificationFields on Notification {
    id
    createdAt
    updatedAt
    configId
    recipientId
    recipientAddress
    senderId
    subject
    body
    queuedAt
    sentAt
    status
    clientId
  }
`;
export const NOTIFICATIONS = gql `
  ${NOTIFICATION_FIELDS}
  query NOTIFICATIONS($spec: NotificationSpec!) {
    notifications(spec: $spec) {
      page
      pageSize
      total
      items {
        ...NotificationFields
      }
    }
  }
`;
